"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NotificationSubscription = void 0;
const ModelCommon_1 = require("../ModelCommon");
const enums_1 = require("./enums");
const NotificationTypes_1 = require("./NotificationTypes");
const typeName = 'NotificationSubscription';
class NotificationSubscription extends ModelCommon_1.ModelCommon {
    // pk either user or self
    // dpk === NotificationSubscription
    // dsk === Incident or other grouping hash
    constructor({ ...ob }) {
        super(typeName, ob);
        this.incidentProducingTypeId = ob.incidentProducingTypeId;
        this.incidentEntityOrGroupingSk = ob.incidentEntityOrGroupingSk;
        this.incidentEntityOrGroupingName = ob.incidentEntityOrGroupingName;
        this.incidentInitiatorSk = ob.incidentInitiatorSk;
        this.filter = ob.filter ?? { severities: [], statuses: [] };
        if (ob.filter?.severities)
            this.filter.severities = ob.filter.severities;
        if (ob.filter?.statuses)
            this.filter.statuses = ob.filter.statuses;
        if (ob.filter?.onActions)
            this.filter.onActions = ob.filter.onActions;
        this.subscriptionState = ob.subscriptionState ?? { status: enums_1.SubscribedStatus.ACTIVE };
        this.deliveryPreferences = ob.deliveryPreferences ?? [];
        this.incidentType = ob.incidentType;
        this.incidentSubtype = ob.incidentSubtype;
        this.updateDynamicKeys();
    }
    updateDynamicKeys() {
        const { incidentEntityOrGroupingSk, incidentType, incidentSubtype, incidentInitiatorSk } = this;
        this.dsk = (0, NotificationTypes_1.getNotificationSubscriptionDSK)({ incidentEntityOrGroupingSk, incidentType, incidentSubtype, incidentInitiatorSk });
        this.dpk = this.type;
    }
}
exports.NotificationSubscription = NotificationSubscription;
